import { MatchedVenueCard } from '../../../../../Components/Cards/VenueCards/VenueCards'
import { MatchedVenueCardFragment } from '../../../../../Components/Cards/VenueCards/VenueCards.generated'
import VenueCardContainer from '../../../../../Components/Material/Card/CardContainer'
import { CardListItem } from '../../../../../Components/Material/Card/CardStyles'
import EmptyState from '../../../../../Components/Material/Card/EmptyState'

interface MatchedVenuesProps {
  matches: Array<MatchedVenueCardFragment | null>
  compact: boolean
}

const MatchedVenues = ({
  matches,
  compact,
}: MatchedVenuesProps): JSX.Element => {
  const matchCards = matches.map((interest) => {
    if (!interest) {
      throw new Error('Message was null')
    }
    return (
      <CardListItem key={interest.id}>
        <MatchedVenueCard {...interest} />
      </CardListItem>
    )
  })

  return (
    <VenueCardContainer
      title='Your matches with venues ♥️️'
      subtitle='Your favourite venues have your contact details and will be in touch soon.'
      compact={compact}
      emptyState={
        <EmptyState contentType='matches'>
          Match with venues and they will appear here.
        </EmptyState>
      }
    >
      {matchCards}
    </VenueCardContainer>
  )
}

export default MatchedVenues
